import ShortcodeSearch from "./Components/ShortcodeSearch";
import ShortcodeResults from "./Components/ShortcodeResults";
import { CmsContent } from "../../Model/CmsContent/CmsContent";
import HeaderFooterWrapper from "../../Components/Navigation/HeaderFooterWrapper";
import { useState } from "react";
import { ShortcodeSummary } from "../../Model/Shortcode/ShortcodeSummary";
import { optHtmlContent, renderDynamicContent } from "../../Utilities/CmsUtilities";

interface ShortcodeSearchPageProps {
    cmsContent: CmsContent[]
}

const ShortcodeSearchPage = (props: ShortcodeSearchPageProps): JSX.Element => {
    const [shortcodeSummary, setShortcodeSummary] = useState<ShortcodeSummary | undefined>()
    const shortcodeIntro = optHtmlContent(props.cmsContent, "sp-pane-shortcode-intro")
    const shortcodeDetails = optHtmlContent(props.cmsContent, "sp-pane-shortcode-details")
    return <>
        <HeaderFooterWrapper cmsContent={props.cmsContent} variant="primary">
            <div style={{fontFamily: "Gotham Rounded SSm A, Gotham Rounded SSm B"}}>
                <div className="sp-card sp-card-white layout-root responsive-body pb-0">
                    {shortcodeIntro && renderDynamicContent(shortcodeIntro)}
                    <div>
                        <ShortcodeSearch onSearch={setShortcodeSummary}/>
                        <br/>
                        {shortcodeSummary && <ShortcodeResults shortcodeSummary={shortcodeSummary}/>}
                    </div>
                </div>
                {shortcodeDetails && renderDynamicContent(shortcodeDetails)}
            </div>
        </HeaderFooterWrapper>
    </>
}

export default ShortcodeSearchPage